import Crud from '@/stores/crudBase';
import api from '@/apis/opening/openingAccountEntryAPI.js';
var crud = new Crud('openingAccountEntry', api);

const state = {
  ...crud.state,
  _config: {
    table: 'opening_account_entry',
    field: {
      code: 'account_number',
      name: 'account_name',
      key: 'ref_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Lấy liệu cho màn list detail trừ tab vthh dùng entity khác
   * @param {*} context
   * @param {*} payload
   * @returns
   * nvtoan2 15/09/2022 sửa lại service để call lấy list detail cho tất cả các tab
   */
  async getAccountBalanceListDetail(context, payload) {
    return await api.getAccountBalanceListDetail(payload || {});
  },

  /**
   * Xóa số dư tài khoản
   * Created by NNkiem 22.09.2022
   */
  async deleteAccountBlanace(context, payload) {
    let res = await api.deleteAccountBlanace(payload.filters || '');

    let errValidate = ['VALIDATE', 'Business', 'Exception'];
    let keyField = context.state._config.field.key;
    //Danh sách gửi lên xóa
    let deleted = [...payload.Models];
    if (keyField && res) {
      for (let i = 0; i < res.length; i++) {
        // Nếu không xóa được thì loại bỏ khỏi list xóa
        if (errValidate.find(x => x === res[i]?.Code)) {
          if (res[i] && res[i].Data && res[i].Data.Data) {
            let itemError = payload.Models[res[i].Index];
            //Loại đi những bản ghi không xóa được
            deleted = deleted.filter((item, index) => {
              return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
            });
          }
        }
      }
    }

    //Commit thực hiện xóa
    context.commit('deleteItems', deleted);

    return res;
  },

  /**
   * Update multiple
   * bnanh 23.06.2022
   */
  async addAndUpdateData(context, param) {
    let res = await api.addAndUpdateData(param);
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
